import { render, staticRenderFns } from "./ReviewsModal.vue?vue&type=template&id=07be0f2f"
import script from "./ReviewsModal.vue?vue&type=script&lang=js"
export * from "./ReviewsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports